module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter menu name"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Menu has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create menu")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10c95b98","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/menu/New.vue
// module id = 821
// module chunks = 0